/* Make importing the Icon component easier as `@iconify/react` doesn't show up in autocomplete. */

import { Icon } from '@iconify/react';

export { Icon };

export function StandardIcon({
  id,
  size,
  onClick,
  className,
  color,
}: {
  id: string;
  size?: number;
  onClick?: () => void;
  className?: string;
  color?: string;
}) {
  const width = size || 20;
  const height = size || 20;

  return (
    <Icon
      icon={id}
      width={width}
      height={height}
      color={color}
      className={`${!color ? 'text-default-600' : ''} ${className} `}
      onClick={onClick}
    />
  );
}
